<div class="cover-starting-date">
  <h5>{{ title }}</h5>
  <ng-content></ng-content>
</div>
